export let EPageType=function(EPageType){EPageType["modal"]="modal";EPageType["fullScreen"]="fullScreen";EPageType["stack"]="stack";return EPageType;}({});